import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared/shared.module';

import { PublicRoutingModule } from './public-routing.module';
import { HomeComponent } from './home/home.component';

import { LayoutsModule } from '@layouts/layouts.module';
import { LoginComponent } from './login/login.component';
import { ErrorComponent } from './error/error.component';


@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    ErrorComponent
  ],
  imports: [
    SharedModule,
    PublicRoutingModule,
    LayoutsModule
  ]
})
export class PublicModule { }
